import * as Unicode from "./unicode.ts";

export enum Match {
  None = 0,
  /// found in subword
  Part = 1,
  /// found full word or phrase
  Full = 2,
  /// found full word or phrase and case matched
  FullCase = 3,
}

export type MatchTable = Map<string, Match>;

export function createMatchTable(words: string[]): MatchTable {
  const map: MatchTable = new Map();
  for (const word of words) {
    map.set(word, Match.None);
  }
  return map;
}

export function updateMatchTable(table: MatchTable, input: string) {
  const inputLower = input.toLowerCase();

  table.forEach((match: Match, word: string) => {
    // for (const [word, match] of table) {
    const wordLower = word.toLowerCase();
    let j = -1;
    while (-1 !== (j = inputLower.indexOf(wordLower, ++j))) {
      const k = j + word.length;

      if (
        (j !== 0 && Unicode.isWord(inputLower.charCodeAt(j - 1))) ||
        (k !== input.length && Unicode.isWord(inputLower.charCodeAt(k)))
      ) {
        if (match < Match.Part) {
          table.set(word, Match.Part);
        }
      } else {
        if (word === input.substring(j, k)) {
          table.set(word, Match.FullCase);
          break;
        }
        if (match < Match.Full) {
          table.set(word, Match.Full);
        }
      }
    }
  });
}
